"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useStoryblokApi;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _ramda = require("ramda");

var initialResult = {
  stories: []
};

function useStoryblokApi(query) {
  var _useState = (0, _react.useState)(initialResult),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var ref = (0, _react.useRef)(result);
  (0, _react.useEffect)(function () {
    if (query && !(0, _ramda.equals)(query, ref.current)) {
      ref.current = query;
      window.storyblok.getAll((0, _objectSpread2["default"])({}, query), function (response) {
        return setResult(response);
      });
    }
  }, [query]);
  return result;
}